import { FB_PIXEL_ACCESS } from '@/helpers/permissionsConstant'

export default [
  {
    title: 'Facebook Pixel',
    route: 'admin-facebook-pixel',
    icon: 'ActivityIcon',
    gate: FB_PIXEL_ACCESS,
  },
]
